import { Badge } from "../ui/badge"
import { motion } from "framer-motion"
import { ProjectCard } from "../project-card"
import { GradientText } from "../animated-text"
import { theme } from "../../theme.js";
import { projectInfo } from "../../data/projectInfo";

const Projects = () => {
  return (
    <section id="projects" className="relative py-12 md:py-32 bg-zinc-50 dark:bg-black overflow-hidden body-font">
      {/* Background Decorators */}
      <div className="absolute bottom-1/4 left-1/4 w-[600px] h-[600px] bg-purple-500/10 blur-[150px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="mb-12 md:mb-24"
        >
          <h2 className="text-4xl md:text-7xl font-bold mb-6 heading-font tracking-tighter text-zinc-900 dark:text-white">
            SELECTED <span className="text-zinc-300 dark:text-zinc-700">WORK</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projectInfo.map((project, index) => (
            <motion.div
              key={project.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="h-full"
            >
              <ProjectCard
                title={project.title}
                description={project.description}
                image={project.image}
                technologies={project.technologies}
                link={project.link}
                color={project.color}
                theme={theme}
                index={index}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
